import React from 'react';
import Button from '../Button';
import BaseModal from './BaseModal';

interface IProps {
    hide(): void;
    content: string;
    header: string;
}

const WarningModal: React.FC<IProps> = (props) => {
    const handleClose = (event: React.SyntheticEvent) => {
        event.preventDefault();
        props.hide();
    }

    const renderContent = () => (
        <div>
            <span className="block pt-3 pb-2 mb-3 text-sm">{props.content}</span>
            <Button text="Close" width="w-full" onClick={handleClose} />
        </div>
    )

    return <BaseModal hide={props.hide} header={props.header} content={renderContent()} />
}

export default WarningModal;
